import { ToasterPrimitive, type ToasterPrimitiveProps } from "../../primitives/toast";

export function Toaster(props: ToasterPrimitiveProps) {
  return <ToasterPrimitive {...props} />;
}

Toaster.displayName = "Toaster";
